function StatusMessage({ type = 'idle', message = '' }) {
  if (!message || type === 'idle') {
    return null;
  }

  return <div className={`status-message ${type}`}>{message}</div>;
}

export default StatusMessage;

